import { render } from "./HBEGroupMapping.vue?vue&type=template&id=5be5419b&scoped=true"
import script from "./HBEGroupMapping.vue?vue&type=script&lang=js"
export * from "./HBEGroupMapping.vue?vue&type=script&lang=js"

import "./HBEGroupMapping.vue?vue&type=style&index=0&id=5be5419b&scoped=true&lang=css"

import exportComponent from "/cwt/data/jenkins/workspace/RoomIt-HotelWeb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5be5419b"]])

export default __exports__